import { render, staticRenderFns } from "./addressform.vue?vue&type=template&id=363b479f&scoped=true"
import script from "./addressform.vue?vue&type=script&lang=js"
export * from "./addressform.vue?vue&type=script&lang=js"
import style0 from "./addressform.vue?vue&type=style&index=0&id=363b479f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "363b479f",
  null
  
)

export default component.exports